module.exports = __webpack_public_path__ + "static/media/diktat-29.22a58239.mp3";